import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'cars/car';
const model = 'cars/car';
const wizardName = 'Revoke synchronization';
const wizardObject = 'Car';
const wizardAction = 'revokeSynchronization';

const RevokeSynchronization = (params) => {
    const { t } = useTranslation();
    const { userCapabilities } = useContext(AppContext);
    const { closeAll } = useDrawer();

    const { doAction, item, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart);

    const detailConfig = {
        "tabs": [
            {
                "name": "revokeSynchronization",
                "fieldsets": [
                    {
                        "name": "revokeSynchronization",
                        "fields": {
                            "revokeMessage": {
                                "type": "sectionmessageblock",
                                "title": "revoke_message_title",
                                "paragraph": "revoke_message_paragraph",
                                "icon": "faTrashCanXmark",
                                "className": "col-12 warning",
                            }
                        }
                    }
                ]
            }
        ],
        "validation": []
    };

    const [editing, setEditing] = useState(false)

    useEffect(() => {
        if (success && editing) {
            closeAll(item?.data);
        }
    }, [success, editing, closeAll, item?.data])
    
    const handleSave = (data) => {
        doAction({ action: wizardAction, model: dataProviderName, data: data });
    }

    return <>
        <DetailComponent
            disableDetailConfigOverride={true}
            values={{ 
                "id": item?.data?._id
            }}
            modelName={model.split('/')[1]}
            detailConfig={detailConfig}
            dataProviderName={dataProviderName}
            onEditing={setEditing}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t(wizardName)}
            canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
            header={
                <InfoHeader
                    view="wizard"
                    title={t(wizardName)}
                    subtitle={t('Revoke the synchronization of the selected car and proceed with a brand new import from Limbo system')}
                />
            }
            {...params}
        />
    </>
}

export default RevokeSynchronization;


